// extracted by mini-css-extract-plugin
export default {"StatCard":"statCard_StatCard__cQfsl","Stats":"statCard_Stats__--1LI","Stat":"statCard_Stat__1H1J4","StatLabel":"statCard_StatLabel__Eb6aB","StatValue":"statCard_StatValue__TtkFc"};